@if (gridFacade.hasSelectedFilters$ | async) {
<div class="filter-clear-button-wrapper">
    <!-- RouterLink to trigger Angular navigation and update SkipLinks -->
    <button
        class="filter-clear-cta"
        (click)="onClearFilters()"
        (keyup.enter)="onClearFilters()"
        [routerLink]="[]"
        i18n-aria-label="@@hermes.accessibility.clear.filters.applied"
        aria-label="Clear filters applied">
        <span i18n="@@hermes_checkout.modules.filters.clear.label"> Clear </span>
    </button>
</div>
}
